import { Settings as SettingsIcon, Plug, Palette, Users, Tag, DatabaseBackup } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/layout/PageHeader";
import { WhatsAppSettings } from "@/components/settings/WhatsAppSettings";
import { BrandingSettings } from "@/components/settings/BrandingSettings";
import { TeamSettings } from "@/components/settings/TeamSettings";
import { TagsSettings } from "@/components/settings/TagsSettings";
import { BackupSettings } from "@/components/settings/BackupSettings";

const TABS = [
  { id: "whatsapp", label: "WhatsApp Cloud API", icon: Plug, C: WhatsAppSettings },
  { id: "branding", label: "Azienda e logo", icon: Palette, C: BrandingSettings },
  { id: "team", label: "Team", icon: Users, C: TeamSettings },
  { id: "tags", label: "Tag", icon: Tag, C: TagsSettings },
  { id: "backup", label: "Backup", icon: DatabaseBackup, C: BackupSettings },
];

export default function Settings() {
  return (
    <div className="h-full flex flex-col">
      <PageHeader title="Impostazioni" subtitle="Configurazione amministratore" icon={SettingsIcon} />
      <div className="flex-1 overflow-y-auto thin-scroll p-4 md:p-8">
        <Tabs defaultValue="whatsapp" className="max-w-4xl">
          <TabsList className="bg-white border border-slate-200 h-11 p-1 w-full sm:w-auto justify-start overflow-x-auto">
            {TABS.map(({ id, label, icon: Icon }) => (
              <TabsTrigger key={id} value={id} data-testid={`settings-tab-${id}`} className="gap-2 data-[state=active]:bg-slate-900 data-[state=active]:text-white">
                <Icon size={14} />{label}
              </TabsTrigger>
            ))}
          </TabsList>
          {TABS.map(({ id, C }) => (
            <TabsContent key={id} value={id} className="mt-6"><C /></TabsContent>
          ))}
        </Tabs>
      </div>
    </div>
  );
}
